$(document).ready(function () {
    var top_nav = $('#top-nav');

    top_nav.find('.dropdown.calculator .dropdown-menu').on('click', function (e) {
        top_nav.find('.calculator-widget [data-value="="]').focus();
        e.stopPropagation();
    });

    var calc_result = 0;
    var calc_prev_entry = 0;
    var calc_operation = null;
    var calc_current_entry = '0';
    var calc_last_pressed = null;

    calc_update_output(calc_current_entry);

    $('.calculator-widget button').on('click', function () {
        var pressed = $(this).html();

        if (pressed == 'C') {
            calc_result = 0;
            calc_prev_entry = 0;
            calc_operation = null;
            calc_current_entry = '0';
        } else if (pressed == 'CE') {
            calc_current_entry = '0';
        } else if (pressed == '+/-') {
            calc_current_entry *= -1;
        } else if (pressed == '.') {
            if (calc_current_entry.indexOf('.') === -1) {
                calc_current_entry += '.';
            }
        } else if (isNumber(pressed)) {
            if (calc_last_pressed == '=') {
                calc_result = 0;
                calc_prev_entry = 0;
                calc_operation = null;
                calc_current_entry = '0';
                calc_last_pressed = null;
            }

            if (calc_current_entry === '0') {
                calc_current_entry = pressed;
            } else {
                calc_current_entry += pressed;
            }
        } else if (isOperator(pressed)) {
            calc_prev_entry = parseFloat(calc_current_entry);
            calc_current_entry = '';
            calc_operation = pressed;
        } else if (pressed == '=') {
            if ((calc_operation !== null) && (calc_prev_entry !== 0) && (calc_current_entry !== '')) {
                calc_current_entry = operate(calc_prev_entry, calc_current_entry, calc_operation);
                calc_operation = null;
            }
        }

        calc_last_pressed = pressed;

        calc_update_output(calc_current_entry);
    });
});

var calc_update_output = function (a) {
    value = a.toString();
    $('.calculator-container .output').html(value.substring(0, 16));
};

var operate = function (prev, current, op) {
    a = parseFloat(prev);
    b = parseFloat(current);

    if (op == '/') {
        if (b == 0) {
            return b;
        } else {
            return a / b;
        }
    } else if (op == 'X') {
        return a * b;
    } else if (op == '-') {
        return a - b;
    } else if (op == '+') {
        return a + b;
    }
};

var isNumber = function (value) {
    return !isNaN(value);
};

var isOperator = function (value) {
    return (value === '/') || (value === 'X') || (value === '-') || (value === '+');
};

var calc_viable_keypress = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '/', '*', '-', '+', '.'];

var calc_viable_keydown = [46, 8];

$(document).on("keypress", function (e) {
    widget = $('.calculator-widget');
    if (widget.is(':visible')) {
        e.stopPropagation();
        if (e.which == 13) { // ENTER
            e.preventDefault();
            widget.find('[data-value="="]').click();
        } else {
            keypress = String.fromCharCode(e.which);
            if (calc_viable_keypress.indexOf(keypress) !== -1) {
                e.preventDefault();
                if (keypress == '*') {
                    widget.find('[data-value="X"]').click();
                } else {
                    widget.find('[data-value="' + keypress + '"]').click();
                }
            }
        }
    }
});

$(document).on("keydown", function (e) {
    widget = $('.calculator-widget');
    if (widget.is(':visible')) {
        if (calc_viable_keydown.indexOf(e.which) !== -1) {
            e.preventDefault();
            if (e.which == 46) { // DELETE
                widget.find('[data-value="C"]').click();
            } else if (e.which == 8) { // BACKSPACE
                widget.find('[data-value="CE"]').click();
            }
        }
    }
});